import React, { useEffect, useState, useRef } from 'react';
import Header from '../Component/Header';
import { FaPlay } from 'react-icons/fa'; // optional, install react-icons if you want (npm i react-icons)

function Video() {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null); // object { video_id, video_name, video_link }
    const [isPlayerOpen, setIsPlayerOpen] = useState(false);
    const videoRef = useRef(null);

    // Fetch videos
    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/getvideos`);
                if (!res.ok) {
                    throw new Error(`Error: ${res.status}`);
                }
                const json = await res.json();

                // controller may return { message, videos } or just array
                const list = json.videos ?? json; // if json is already an array, use it
                // If your API wraps videos inside an object with key 'videos' inside another object, adjust accordingly.
                setVideos(Array.isArray(list) ? list : []);
                setError(null);
            } catch (err) {
                setError(err.message || 'Failed to fetch videos');
            } finally {
                setLoading(false);
            }
        };

        fetchVideos();
    }, []);

    // Close handler that also pauses the video
    const closePlayer = () => {
        if (videoRef.current) {
            try {
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            } catch (e) {
                // ignore
            }
        }
        setIsPlayerOpen(false);
        setSelectedVideo(null);
    };

    // Open player for clicked video
    const openPlayer = (video) => {
        setSelectedVideo(video);
        setIsPlayerOpen(true);
        // allowing time for modal to render, autoplay handled by video attribute
        setTimeout(() => {
            if (videoRef.current) {
                try {
                    // try to play (may be blocked if not muted depending on browser)
                    videoRef.current.play().catch(() => { });
                } catch (e) { }
            }
        }, 150);
    };

    // Close on ESC key
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape' && isPlayerOpen) {
                closePlayer();
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [isPlayerOpen]);

    const generateThumbnail = (videoUrl) => {
        if (!videoUrl) return "";
        return videoUrl
            .replace("/upload/", "/upload/w_600,h_400,so_3/")
            .replace(".mp4", ".jpg");
    };

    return (
        <div>
            <Header />

            <h3 className="text-center" style={{ color: '#000000ff', marginTop: '160px', fontSize: '3rem' }}>
                Videos
            </h3>

            <div className="container p-5">
                {loading ? (
                    <div className="text-center">Loading videos...</div>
                ) : error ? (
                    <div className="text-center text-danger">{error}</div>
                ) : videos.length === 0 ? (
                    <div className="text-center">No videos found</div>
                ) : (
                    <div className="row g-4">
                        {videos.map((v) => (
                            <div
                                key={v.video_id}
                                className="col-12 col-md-6 col-lg-4 col-xl-3"
                            >
                                <div
                                    className="video-card position-relative bg-light"
                                    role="button"
                                    onClick={() => openPlayer(v)}
                                    onKeyDown={(e) => e.key === 'Enter' && openPlayer(v)}
                                    tabIndex={0}
                                    style={{
                                        borderRadius: 8,
                                        overflow: 'hidden',
                                        border: '1px solid #ddd',
                                        cursor: 'pointer',
                                        width: "100%",
                                        height: "390px",   // ⭐ control height here
                                        position: 'relative',
                                        backgroundColor: '#000',
                                    }}
                                >
                                    <img
                                        src={generateThumbnail(v.video_link)}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "fill",
                                            objectPosition: "center",
                                        }}
                                    />

                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            background: 'linear-gradient(180deg, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0.45) 100%)',
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 8,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: '50%',
                                                    background: 'rgba(0,0,0,0.5)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '2px solid rgba(255,255,255,0.85)',
                                                }}
                                            >
                                                <FaPlay />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                )}

                {/* Player Modal / Lightbox */}
                {isPlayerOpen && selectedVideo && (
                    <div
                        className="video-modal"
                        style={{
                            position: 'fixed',
                            zIndex: 1100,
                            inset: 0,
                            background: 'rgba(0,0,0,0.7)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '20px',
                        }}
                        onClick={(e) => {
                            // close if backdrop clicked
                            if (e.target === e.currentTarget) closePlayer();
                        }}
                    >
                        <div
                            className="video-modal-inner"
                            style={{
                                width: '100%',
                                maxWidth: '1200px',
                                maxHeight: '90vh',
                                width: '100%',
                                maxWidth: '900px',
                                background: '#fff',
                                borderRadius: 12,
                                overflow: 'hidden',
                                position: 'relative',
                            }}
                        >
                            {/* Close button */}
                            <button
                                aria-label="Close"
                                onClick={closePlayer}
                                style={{
                                    position: 'absolute',
                                    right: 12,
                                    top: 12,
                                    zIndex: 5,
                                    background: 'rgba(0,0,0,0.6)',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 6,
                                    padding: '6px 10px',
                                    cursor: 'pointer',
                                }}
                            >
                                Close
                            </button>

                            {/* Video player */}
                            <div
                                style={{
                                    width: '100%',
                                    aspectRatio: '16 / 9',
                                    background: '#000',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <video
                                    ref={videoRef}
                                    src={selectedVideo.video_link}
                                    controls
                                    autoPlay
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    }}
                                >
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Video;
